import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { BookOpen, ExternalLink } from 'lucide-react';

const resources = [
  {
    title: 'Peptide Reconstitution Guide',
    description: 'Complete guide to properly reconstituting research peptides',
    url: 'https://example.com/reconstitution-guide',
    category: 'Guides'
  },
  {
    title: 'Storage Best Practices',
    description: 'How to store peptides for maximum stability',
    url: 'https://example.com/storage-guide',
    category: 'Guides'
  },
  {
    title: 'Injection Site Guide',
    description: 'Best practices for subcutaneous injections',
    url: 'https://example.com/injection-guide',
    category: 'Guides'
  },
  {
    title: 'Understanding COAs',
    description: 'How to read and verify Certificates of Analysis',
    url: 'https://example.com/coa-guide',
    category: 'Education'
  },
  {
    title: 'Peptide Stability Data',
    description: 'Research on peptide stability and degradation',
    url: 'https://example.com/stability',
    category: 'Research'
  },
  {
    title: 'Dosing Protocols',
    description: 'Common research dosing protocols and schedules',
    url: 'https://example.com/protocols',
    category: 'Research'
  }
];

export default function Resources() {
  return (
    <div className="p-4 md:p-8 max-w-4xl mx-auto">
      <div className="flex items-center gap-3 mb-8">
        <BookOpen className="h-8 w-8 text-primary" />
        <h1 className="text-4xl font-bold">Resources</h1>
      </div>

      <p className="text-muted-foreground mb-8">
        Educational materials and guides for peptide research
      </p>

      <div className="space-y-3">
        {resources.map((resource, index) => (
          <Card key={index} className="p-6 glass-card hover:-translate-y-1 transition-transform duration-200">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-1 rounded-full bg-primary/10 text-primary border border-primary/30">
                    {resource.category}
                  </span>
                </div>
                <h3 className="text-xl font-bold mb-2">{resource.title}</h3>
                <p className="text-muted-foreground">{resource.description}</p>
              </div>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => window.open(resource.url, '_blank')}
              >
                <ExternalLink className="h-5 w-5" />
              </Button>
            </div>
          </Card>
        ))}
      </div>

      <Card className="mt-8 p-6 glass-card bg-warning/10 border-warning/30">
        <p className="text-warning text-sm">
          ⚠️ These resources are for educational purposes only. Always verify information with qualified professionals 
          and comply with local regulations.
        </p>
      </Card>
    </div>
  );
}
